<rid-math
  (finished)="$router.navigate(['/mechanics/formule'])"
  [exercises]="[
    ['add', 5, 3],
    ['subtract', 5, 1],
    ['divide', 6, 3],
    ['multiply', 3, 1],
  ]"
  class="h-dvh"
/>
